import {
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { useLocation } from "react-router-dom";

enum Screen {
  base = "",
  sm = "sm",
  md = "md",
  lg = "lg",
  xl = "xl",
  "2xl" = "2xl",
}
type Context = {
  screen: "" | "sm" | "md" | "lg" | "xl" | "2xl";
  showContactSalesModal: boolean;
  setShowContactSalesModal: (show: boolean) => void;
  goToPricingSection: () => void;
  doGetStarted: () => void;
  doSignIn: () => void;
  goToSection: (sectionId: string) => void;
};

const AppContext = createContext<Context>({
  screen: "",
  showContactSalesModal: false,
  setShowContactSalesModal: () => {},
  goToPricingSection: () => {},
  doGetStarted: () => {},
  doSignIn: () => {},
  goToSection: (sectionId: string) => {}
});

export const AppProvider = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();
  const [screen, setScreen] = useState<Screen>(Screen.base);
  const [showContactSalesModal, setShowContactSalesModal] = useState(false);

  const handleScreenWidth = (e: any) => {
    const width = e?.target?.document?.body?.clientWidth ?? window.innerWidth;
    setScreen(
      width >= 1536
        ? Screen["2xl"]
        : width >= 1280
        ? Screen.xl
        : width >= 1024
        ? Screen.lg
        : width >= 768
        ? Screen.md
        : width >= 640
        ? Screen.sm
        : Screen.base
    );
  };

  const goToPricingSection = () => {
    const pricingSection = document.getElementById("pricing-section");
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const doGetStarted = () => {
    window.open("https://app.intelliroom.ai/auth/sign-up", "_blank");
  };

  const doSignIn = () => {
    window.open("https://app.intelliroom.ai/auth/sign-in", "_blank");
  };

  const goToSection = (sectionId: string) => {
    const sectionElement = document.getElementById(sectionId);
    window.scrollTo({
      top: sectionElement?.offsetTop ? sectionElement?.offsetTop - 100 : 0,
      behavior: "smooth",
    });
  }

  useEffect(() => {
    window.addEventListener("resize", handleScreenWidth);

    handleScreenWidth(window);

    return () => {
      window.removeEventListener("resize", handleScreenWidth);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <AppContext.Provider
      value={{
        screen,
        showContactSalesModal,
        setShowContactSalesModal,
        goToPricingSection,
        doGetStarted,
        goToSection,
        doSignIn
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
